/**
 * The action type that ends a superuser's impersonation in this tab, as a
 * literal string for the same reason as `tenantSwitchActionType.js`: the
 * root-level reset wrapper and the query-cache middleware match on it
 * without importing authSlice.js (and, through it, the api/client -> store
 * cycle). No imports of its own.
 *
 * Dispatched by `useExitImpersonation` once `POST /auth/impersonate/exit/`
 * succeeds and before `/auth/me` is refetched: the tenant the app was
 * pinned to is no longer the session's, so every tenant-scoped slice and
 * cached query is dropped, exactly as a tenant switch drops them.
 */
export const IMPERSONATION_EXITED = 'auth/impersonationExited'
